import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getBeefVisualNoiceList(params) {
  return request({
    url: '/GetBeefVisualNoiceList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 2000000001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        // NoticeDateTime: params.NoticeDateTime,
        VisualState: params.VisualState
      }
    }
  })
}

export function addBeefVisualNoice(params) {
  return request({
    url: '/AddBeefVisualNoice',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 113,
      MessageID: btcguid(),
      Data: {
        NoticeDate: params.NoticeDate,
        NoticeTime: params.NoticeTime,
        NoticeDateTime: params.NoticeDateTime,
        Content: params.Content,
        Explain: params.Explain,
        ExplainScond: params.ExplainScond,
        ExplainThird: params.ExplainThird,
        ExplainFourth: params.ExplainFourth,
        ExplainFifth: params.ExplainFifth,
        ColourNo: params.ColourNo,
        FontSize: params.FontSize,
        VisualState: params.VisualState
      }
    }
  })
}

export function updateBeefVisualNoice(params) {
  return request({
    url: '/UpdateBeefVisualNoice',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000010,
      MessageID: btcguid(),
      Data: {
        NoticeDate: params.NoticeDate,
        NoticeTime: params.NoticeTime,
        NoticeDateTime: params.NoticeDateTime,
        Content: params.Content,
        VisualState: params.VisualState,
        Explain: params.Explain,
        ExplainScond: params.ExplainScond,
        ExplainThird: params.ExplainThird,
        ExplainFourth: params.ExplainFourth,
        ExplainFifth: params.ExplainFifth,
        ColourNo: params.ColourNo,
        FontSize: params.FontSize,
        ID: params.ID
      }
    }
  })
}

export function getBeefVisualPersonList(params) {
  return request({
    url: '/GetBeefVisualPersonList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 7301,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        BeefVisualNoiceID: params.ID,
        KeyWord: params.Keywords
      }
    }
  })
}

export function getBeefVisualAdvanceRecordList(params) {
  return request({
    url: '/GetBeefVisualAdvanceRecordList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 7301,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        BeefVisualNoiceID: params.ID,
        KeyWord: params.Keywords
      }
    }
  })
}

export function getBeefVisualCommentList(params) {
  return request({
    url: '/GetBeefVisualCommentList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 2000000001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        BeefVisualNoiceID: params.ID,
        KeyWord: params.Keywords
      }
    }
  })
}

export function getBeefVisualPersonStatisticsList(params) {
  return request({
    url: '/GetBeefVisualPersonStatisticsList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 2000000001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.Keywords,
        BeefVisualNoiceID: params.ID
      }
    }
  })
}

export function deleteBeefVisualComment(params) {
  return request({
    url: '/DeleteBeefVisualComment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 2000000001,
      MessageID: btcguid(),
      Data: {
        ID: params.ID
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/visual.js